export default __webpack_public_path__ + "static/media/001-angel.d858e6e2.svg";